app.controller('Menu', function ($scope) {
	$scope.menuActive = function() {
	    $scope.selectedItem = false;
	};
});